import { usePositions } from "@/hooks/usePositions";
import { formatINR } from "@/lib/format";

export default function Compare() {
  const { positions: realPositions } = usePositions("REAL");
  const { positions: virtualPositions } = usePositions("VIRTUAL");

  const realPnl = realPositions.reduce((s, p) => s + (p.pnl ?? 0), 0);
  const virtualPnl = virtualPositions.reduce((s, p) => s + (p.pnl ?? 0), 0);
  const realInvested = realPositions.reduce((s, p) => s + (p.invested ?? 0), 0);
  const virtualInvested = virtualPositions.reduce((s, p) => s + (p.invested ?? 0), 0);

  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 20 }}>
        Real vs Virtual — Comparison
      </h1>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
        {/* Real */}
        <div className="card">
          <h2 style={{ fontSize: 14, fontWeight: 600, color: "var(--green-light)", marginBottom: 12, textTransform: "uppercase" }}>
            Real Trading
          </h2>
          <div style={{ marginBottom: 8 }}>
            <span style={{ color: "var(--text-muted)", fontSize: 12 }}>Positions:</span>
            <span style={{ marginLeft: 8, fontFamily: "var(--font-mono)" }}>{realPositions.length}</span>
          </div>
          <div style={{ marginBottom: 8 }}>
            <span style={{ color: "var(--text-muted)", fontSize: 12 }}>Invested:</span>
            <span style={{ marginLeft: 8, fontFamily: "var(--font-mono)" }}>{formatINR(realInvested)}</span>
          </div>
          <div>
            <span style={{ color: "var(--text-muted)", fontSize: 12 }}>P&L:</span>
            <span style={{ marginLeft: 8, fontFamily: "var(--font-mono)", color: realPnl >= 0 ? "var(--green-light)" : "var(--red-light)" }}>
              {formatINR(realPnl)}
            </span>
          </div>
        </div>

        {/* Virtual */}
        <div className="card">
          <h2 style={{ fontSize: 14, fontWeight: 600, color: "var(--amber)", marginBottom: 12, textTransform: "uppercase" }}>
            Virtual Trading
          </h2>
          <div style={{ marginBottom: 8 }}>
            <span style={{ color: "var(--text-muted)", fontSize: 12 }}>Positions:</span>
            <span style={{ marginLeft: 8, fontFamily: "var(--font-mono)" }}>{virtualPositions.length}</span>
          </div>
          <div style={{ marginBottom: 8 }}>
            <span style={{ color: "var(--text-muted)", fontSize: 12 }}>Invested:</span>
            <span style={{ marginLeft: 8, fontFamily: "var(--font-mono)" }}>{formatINR(virtualInvested)}</span>
          </div>
          <div>
            <span style={{ color: "var(--text-muted)", fontSize: 12 }}>P&L:</span>
            <span style={{ marginLeft: 8, fontFamily: "var(--font-mono)", color: virtualPnl >= 0 ? "var(--green-light)" : "var(--red-light)" }}>
              {formatINR(virtualPnl)}
            </span>
          </div>
        </div>
      </div>

      <div className="card" style={{ marginTop: 24 }}>
        <h2 style={{ fontSize: 14, fontWeight: 600, marginBottom: 12 }}>P&L Comparison Chart</h2>
        <div style={{ padding: 40, textAlign: "center", color: "var(--text-muted)" }}>
          Chart visualization coming soon — will display real-time P&L comparison
        </div>
      </div>
    </div>
  );
}
